import { resolveStorefrontPreset } from "../presentation/presets";

export const CATEGORY_NAVIGATION_MODES = {
  DRILL_DOWN: "drill-down",
  INLINE: "inline",
  COLLAPSIBLE: "collapsible",
  STICKY: "sticky",
};

const navigationByLayout = {
  grid: { mode: CATEGORY_NAVIGATION_MODES.DRILL_DOWN, variant: "tiles" },
  grid2: { mode: CATEGORY_NAVIGATION_MODES.DRILL_DOWN, variant: "tiles" },
  list: { mode: CATEGORY_NAVIGATION_MODES.INLINE, variant: "sections" },
  jumbo: { mode: CATEGORY_NAVIGATION_MODES.INLINE, variant: "sections" },
  "list-collapse": {
    mode: CATEGORY_NAVIGATION_MODES.COLLAPSIBLE,
    variant: "sections",
  },
  scroll: { mode: CATEGORY_NAVIGATION_MODES.INLINE, variant: "rail" },
  bubbles: { mode: CATEGORY_NAVIGATION_MODES.STICKY, variant: "bubbles" },
};

export const resolveCategoryNavigation = (settings = {}) => {
  const preset = resolveStorefrontPreset(settings);
  const navigation = navigationByLayout[preset.id];
  const headerStyle = preset.navigation.controlStyle;
  const showHeader =
    navigation.mode !== CATEGORY_NAVIGATION_MODES.DRILL_DOWN &&
    settings.categories_layout !== "none" &&
    headerStyle !== "none";

  return {
    ...navigation,
    layout: preset.id,
    fallbackApplied: preset.fallbackApplied,
    headerStyle,
    showAll: preset.navigation.showAll,
    showHeader,
    sticky:
      showHeader &&
      (navigation.mode === CATEGORY_NAVIGATION_MODES.STICKY ||
        preset.navigation.sticky === true) &&
      settings.categories_layout_sticky !== false,
    collapsedByDefault:
      navigation.mode === CATEGORY_NAVIGATION_MODES.COLLAPSIBLE &&
      preset.navigation.collapsedByDefault,
  };
};

export const getCollapsibleCategoryIndexes = (categories = []) =>
  (Array.isArray(categories) ? categories : []).reduce((indexes, category, index) => {
    if (Array.isArray(category?.products) && category.products.length) {
      indexes.push(index);
    }
    return indexes;
  }, []);
